import { default as TicketHeader } from '../_internal/components/TicketHeader';
export default TicketHeader;